import React, { ReactNode } from 'react';
import { Modal } from '@kvdbil/components';
import styled from 'styled-components';
import { useIsDevice } from '../hooks/useIsDevice';

const StyledModal = styled(Modal)`
  z-index: 1000000;
  button {
    justify-self: center;
    margin-top: 1rem;
  }
`;

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  contentStyles?: React.CSSProperties;
  children?: ReactNode;
}

const Lightbox = ({
  isOpen = true,
  onClose,
  contentStyles,
  children
}: Props) => {
  const handleClose = () => {
    onClose?.();
  };
  const { isMobile } = useIsDevice();

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={handleClose}
      withCloseIcon={false}
      contentStyles={{
        padding: isMobile ? '0' : '1rem',
        ...contentStyles
      }}
    >
      {children}
    </StyledModal>
  );
};

export default Lightbox;
